module.exports = __webpack_public_path__ + "components/app-store/static/ios__qr-download-en-0537865dfecebfbac87f13d4d20556b8.svg";